import React from 'react';

import { Timeline } from 'react-twitter-widgets';

const NewsSection = () => {
  return (
    <div className="box">
      <h3 className="subtitle">News</h3>
      <div className="mx-auto">
        <Timeline
          dataSource={{
            sourceType: 'profile',
            screenName: 'banksy_dao',
          }}
          options={{
            height: '280',
            chrome: 'noheader, nofooter',
            width: '400',
            theme: 'dark',
          }}
        />
      </div>
    </div>
  );
}

export default NewsSection;
